export const ADJUSTMENTS_FORM_DATASET_NAME = 'set_adjustments';
